import React from 'react';

export const ActiveFiltersText = ({ texts }: ActiveFiltersProps) => {
  return (
    <div className={'flex gap-2 text-sm'}>
      <span className={'color-primary'}>Filtres actifs :</span>
      <div className={'m-0! flex gap-2'}>
        {texts.map((text, index) => (
          <div className={'flex gap-2'} key={index}>
            {(index > 0) && <span className={'font-medium color-primary'}>+</span>}
            <span>{text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

interface ActiveFiltersProps {
  texts: string[];
}